  <style lang="scss" scoped>
  #app {
    min-height: 100vh;
    background: #ecececa3;
  }
  .app-layout {
    display: flex;
    // height:100vh;
    height: 100%;
  }
  .main {
    width: 100%;
  }
  </style>

  <template>
    <div class="app-layout">
      <AppSideBar
        v-if="
          $route.name !== 'UserProblemDetail' &&
            $route.name !== 'DetailUserAnswer'
        "
          class="main-side-bar"
          :toggleCollapsed="toggleCollapsed"
      />
      <div class="main" :style="toggleCollapsed ? '' : 'width: calc(100% - 197px);' ">
        <AppHeader
          :toggleCollapsed="toggleCollapsed"
          @toggle-collapsed="handleToggleCollapsed"
        />
        <!-- <div class="main-content p-2"> -->
        <router-view></router-view>
      </div>
    </div>
  </template>

  <script>
  import AppSideBar   from "./../components/layouts/AppSideBar";
  import AppHeader    from "./../components/layouts/AppHeader";
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters({
        user: "auth/user",
      })
    },
    components: {
      AppSideBar,
      AppHeader
    },
    data() {
      return {
        toggleCollapsed: false
      };
    },
    created() {
        if(this.user) {
            if (this.user.business_id) {
                this.toggleCollapsed = true;
            } else {
                this.toggleCollapsed = this.user.roles_teacher === 5 ? window.innerWidth < 992 : false
            }
        }
    },
    methods: {
      handleToggleCollapsed() {
        this.toggleCollapsed = !this.toggleCollapsed;
      }
    }
  };
  </script>

  <style lang="scss">
  .app-layout {
    background-color: #e5eaff;
  }

  .main-content {
    background: #e5eaff;
    height: 100vh;
  }

  .required:after {
    content: " *";
    color: red;
  }

  @media only screen and (max-width: 992px) {
    .main-content {
      margin: 0;
    }
  }
  </style>
